import { z } from 'zod';

/** @see Manzanita.Associations.AssociationType */
export type AssociationType = z.infer<typeof associationTypeSchema>;

/** @see Manzanita.Associations.AssociationType */
export const associationTypeSchema = z.enum([
	'CustomerGroup',
	'Customer',
	'Plant',
	'Country',
	'CustomerGroupPlant',
	'CustomerGroupCountry',
	'All',
	'UserRole',
]);
